module.exports = __webpack_public_path__ + "img/3.9abc5698.jpg";